// @flow

import * as React from 'react';
import OverflowUIList from './OverflowUIList';
import OverflowOpener from './OverflowOpener';
import OverflowIcon from './OverflowIcon';
import type { OverflowDirection } from './OverflowOpener';

export type IconHoverColorType = 'GREEN' | 'WHITE';

type Props = {
  className?: string,
  /** child, if any, is an element of type OverflowUIList */
  children?: ?React.Element<typeof OverflowUIList>,
  /** Whether this should close when the user scrolls the page */
  closeOnScroll?: boolean,
  onClick?: (SyntheticMouseEvent<HTMLElement>) => mixed,
  /** How much to horizontally shift the popover menu in pixels */
  popoverShiftX?: number,
  /** How much to verfically shift the popover menu in pixels */
  popoverShiftY?: number,
  /** How much to shift the attached arrow on the popover menu */
  popoverShiftArrow?: number,
  /** Which way the overflow menu should go */
  overflowDirection?: OverflowDirection,
  /** Provided color for icons */
  iconColor?: 'WHITE' | 'GRAY',
  /** On hover color  */
  iconHoverColor?: IconHoverColorType,
};

/**
 * OverflowUI provides an button that looks like an ellipses (...) that, when activated, opens a
 * popover menu. The popover menu's contents are defined by the children passed into OverflowUI.
 * @todo: add support for non-list contents to do things like toggle-able confirmation buttons within the overflowUI
 */
const OverflowUI = ({
  children,
  className,
  closeOnScroll,
  onClick,
  popoverShiftX,
  popoverShiftY,
  popoverShiftArrow,
  overflowDirection,
  iconColor,
  iconHoverColor,
}: Props) => (
  <div className={`overflow ${className || ''}`}>
    <OverflowOpener
      overflowList={children}
      closeOnScroll={closeOnScroll}
      shiftX={popoverShiftX}
      shiftY={popoverShiftY}
      shiftArrow={popoverShiftArrow}
      overflowDirection={overflowDirection}
    >
      {(target, toggle) => (
        <OverflowIcon
          ref={target}
          color={iconColor}
          hoverColor={iconHoverColor}
          onClick={e => {
            toggle();
            if (onClick) {
              onClick(e);
            }
          }}
        />
      )}
    </OverflowOpener>
  </div>
);

OverflowUI.defaultProps = {
  className: undefined,
  children: undefined,
  closeOnScroll: false,
  onClick: undefined,
  popoverShiftX: 0,
  popoverShiftY: 0,
  popoverShiftArrow: 0,
  overflowDirection: undefined,
};

export default OverflowUI;
